import React from "react";
import { Alert } from "./Alert";

interface SessionExpiredBannerProps {
  onReAuthenticate: () => void;
}

export function SessionExpiredBanner({ onReAuthenticate }: SessionExpiredBannerProps) {
  return (
    <div className="px-4 pt-4">
      <Alert
        variant="warning"
        size="small"
        title="Your session has expired. Please sign in again."
        actionLabel="Sign in"
        onActionClick={onReAuthenticate}
      />
    </div>
  );
}
